import React from "react";
import { V2Button } from "@abyss/web/ui/Button";
import { IconSymbol } from "@abyss/web/ui/IconSymbol";
import { V2Link } from "@abyss/web/ui/Link";

import classNames from "classnames";
import styles from "./breadcrumb.module.css";

export const Breadcrumb = ({ linkText, location }) => {
  return (
    <div className={styles.breadcrumb}>
      <div>
        <div>
          <V2Button
            variant="text"
            icon={{ icon: "chevron_left", position: "leading" }}
            css={{ padding: "0" }}
          >
            {linkText}
          </V2Button>
        </div>
      </div>
      <div className={styles.options}>
        {location && (
          <div>
            <div className={styles.zip}>
              <div className={styles.zipIcon}>
                <IconSymbol icon="location_on" color="$primary1" />
              </div>
              <div className={styles.zipCopy}>
                <div className={styles.zipLabel}>Your plan details for</div>
                <div className={styles.zipButton}>
                  <V2Link href="#link" variant="underlined" fontWeight="$bold">
                    {location}
                    <span>
                      <IconSymbol icon="edit" size="18" />
                    </span>
                  </V2Link>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className={styles.noMobile}>
          <V2Button
            variant="text"
            icon={{ icon: "email", position: "leading" }}
            css={{
              padding: "0",
              "abyss-button-leading-icon": {
                fontSize: "20px !important",
              },
            }}
          >
            Email
          </V2Button>
        </div>
        <div className={styles.noMobile}>
          <V2Button
            variant="text"
            icon={{ icon: "print", position: "leading" }}
            css={{
              padding: "0",
              "abyss-button-leading-icon": {
                fontSize: "20px !important",
              },
            }}
          >
            Print
          </V2Button>
        </div>
      </div>
    </div>
  );
};
